import React, { useMemo, useState } from 'react';
import { RateCardPicker, rateCardById } from '@/lib/rateCards';

const IN = 'h-9 w-full rounded-lg border border-input bg-background px-2 font-mono text-sm text-foreground';

// Rate-card way of re-pricing whole approvals: one gold 999 rate, one labour rate and one rate per raw-material name for every piece.
export function RateCardApply({ drafts, onApply, card, setCard, onGold }) {
  const labels = useMemo(() => [...new Set(drafts.flatMap((x) => x.lines.map((l) => l.label)))].sort(), [drafts]);
  const [gold, setGold] = useState('');
  const [labour, setLabour] = useState('');
  const [rates, setRates] = useState({});
  const pickCard = (id) => {
    setCard(id);
    const c = rateCardById(id);
    if (!c) return;
    setLabour(c.labour != null ? String(c.labour) : '');
    setRates(Object.fromEntries(labels.filter((l) => (c.lines || {})[l] != null).map((l) => [l, String(c.lines[l])])));
  };
  const apply = () => {
    const g = gold === '' ? null : Number(gold);
    if (g != null) onGold?.(String(g));
    onApply(drafts.map((x) => ({
      ...x,
      ...(g != null ? { goldRate: Math.round((g * (Number(x.item.purity_pct) || 0)) / 100) } : {}),
      ...(labour !== '' ? { labourRate: Number(labour) } : {}),
      lines: x.lines.map((l) => (rates[l.label] != null && rates[l.label] !== '' ? { ...l, rate: Number(rates[l.label]) } : l)),
    })));
  };
  return (
    <div className="space-y-3 rounded-xl border border-violet-500/30 bg-violet-500/5 p-3" data-testid="tagws-rates-card-panel">
      <div className="grid gap-2 sm:grid-cols-3">
        <label className="text-xs font-semibold text-muted-foreground">Rate card<RateCardPicker value={card} onChange={pickCard} className="!mt-1 !h-9 !max-w-none w-full" testid="tagws-rates-card" /></label>
        <label className="text-xs font-semibold text-muted-foreground">Gold rate (100%) per g<input type="number" min="0" value={gold} onChange={(e) => setGold(e.target.value)} placeholder="keep" className={`${IN} mt-1`} data-testid="tagws-rates-gold" /></label>
        <label className="text-xs font-semibold text-muted-foreground">Labour per g<input type="number" min="0" value={labour} onChange={(e) => setLabour(e.target.value)} placeholder="keep" className={`${IN} mt-1`} data-testid="tagws-rates-labour" /></label>
      </div>
      {labels.length ? <div className="grid gap-2 sm:grid-cols-3" data-testid="tagws-rates-lines">{labels.map((l) => (
        <label key={l} className="text-xs font-semibold text-muted-foreground"><span className="block truncate">{l} per ct</span>
          <input type="number" min="0" value={rates[l] ?? ''} onChange={(e) => setRates((r) => ({ ...r, [l]: e.target.value }))} placeholder="keep" className={`${IN} mt-1`} data-testid="tagws-rates-line" /></label>))}</div> : null}
      <div className="flex items-center justify-between gap-2">
        <p className="text-[length:calc(var(--fs,1)*0.6875rem)] text-muted-foreground">Boxes left blank keep each piece's current rate. Check the pieces below, then save.</p>
        <button type="button" onClick={apply} className="h-9 shrink-0 rounded-lg bg-violet-700 px-3 text-xs font-semibold text-white hover:bg-violet-800" data-testid="tagws-rates-apply">Apply to all {drafts.length} pieces</button>
      </div>
    </div>
  );
}
